import { put, call } from "redux-saga/effects";
import axios from "../../../config/AxiosConfig";
import { ISSUER_ACCOUNTS_API } from "../../actions/apiCollections";
import {
  getIssuerAccountsStart,
  getIssuerAccountsFail,
  getIssuerAccountsSuccess,
  getIssuerAccountSuccess,
} from "../../actions/issuerVerification/issuerVerificationActions";

export function* getIssuerAccountsSaga(action) {
  yield put(getIssuerAccountsStart());
  try {
    const response = yield axios.get(ISSUER_ACCOUNTS_API + "admin", {
      params: {
        ...(action?.search?.search !== "" && {
          search: action?.search?.search
        }),
        ...(action?.search?.status !== "" && {
          status: action?.search?.status
        }),
        limit: 10 * (action.pageLimit || 1),
        page: action.page || 1,
      },
    });
    yield put(getIssuerAccountsSuccess(response.data?.data));
  } catch (error) {
    yield put(getIssuerAccountsFail(error));
  }
}

export function* getIssuerAccountSaga(action) {
  try {
    const response = yield axios.get(ISSUER_ACCOUNTS_API + action.id + "/admin");
    yield put(getIssuerAccountSuccess(response.data?.data));
  } catch (error) {
    yield put(getIssuerAccountsFail(error));
  }
}

export function* issuerAccountActionSaga(action) {
  try {
    yield axios.patch(
      ISSUER_ACCOUNTS_API + action.accData.id + "/admin",
      action.accData
    );
    yield call(getIssuerAccountsSaga, { pageLimit: 1, page: 1, search: { status: 'pending' } });
    yield call(getIssuerAccountSaga, { id: action.accData.id });
  } catch (error) {
    yield put(getIssuerAccountsFail(error));
  }
}
